:host{z-index:inherit}.toolbar-grid{right:var(--ursa--scrollbar-width);bottom:var(--ursa--scrollbar-width)}h3-tag-option-list{align-self:stretch}h3-coordinates-box{justify-self:right}.output-controls{display:flex;gap:4px}
/*# sourceMappingURL=raster-coding-toolbars.component.css.map */
